import { useCallback, useEffect, useRef, useState } from "react";
import type { ToastState } from "../types";

const TOAST_TIMEOUT_MS = 2500;

export const useToast = () => {
  const [toast, setToast] = useState<ToastState | null>(null);
  const toastTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = useCallback(
    (message: string, type: ToastState["type"] = "success") => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }

      setToast({
        id: Date.now(),
        type,
        message: String(message || ""),
      });

      toastTimeoutRef.current = setTimeout(() => {
        setToast(null);
        toastTimeoutRef.current = null;
      }, TOAST_TIMEOUT_MS);
    },
    [],
  );

  useEffect(
    () => () => {
      if (toastTimeoutRef.current) {
        clearTimeout(toastTimeoutRef.current);
      }
    },
    [],
  );

  return { toast, showToast };
};
